import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { SharedClient } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-izmena-osnovice-dropdown',
  templateUrl: './izmena-osnovice-dropdown.component.html',
  styleUrls: ['./izmena-osnovice-dropdown.component.scss'],
})
export class IzmenaOsnoviceDropdownComponent implements OnInit, OnDestroy {
  
  private _subs: Subscription = new Subscription();
  
  /** Props */
  items: SelectItem[] = [];

  /** I/O */
  @Input() formCtrl: AbstractControl;
  @Input() formCtrlId: string;
  @Input() parentCtrl: any = 'body';
 
  constructor(private _client: SharedClient) {
    this._subs = new Subscription();
  }

  ngOnInit(): void {
    this._load();
  }

  private _load() {
    this._subs.add(
      this._client.getPrikazDokumentaOSmanjenjuIPovecanju().subscribe((res) => {
        this.items = res.data.prikazDokumentaOSmanjenjuIPovecanjuDtoList.map(
          (x) => ({
            value: x.prikazIzmenaOsnovice,
            label: x.prikazIzmenaOsnoviceStr,
            title: x.opis,
          })
        );
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
